// Servicio FE DIAN - Sprint 35.
import apiClient from '../../../api/apiClient';
import openProtectedFile from '../../../api/openProtectedFile';

const BASE = '/fe';

export async function listFE({ page = 1, per_page = 25, estado = '' } = {}) {
  const params = new URLSearchParams();
  params.set('page', page);
  params.set('per_page', per_page);
  if (estado) params.set('estado', estado);
  const r = await apiClient.get(BASE + '/?' + params.toString());
  const d = (r && r.data) || {};
  return { items: d.items || [], total: d.total || 0 };
}

export async function getFE(id) {
  const r = await apiClient.get(BASE + '/' + id);
  return (r && r.data) || null;
}

export async function getFEByVenta(ventaId) {
  const r = await apiClient.get(BASE + '/por-venta/' + ventaId);
  return (r && r.data) || null;
}

export async function enviarFE(id) {
  const r = await apiClient.post(BASE + '/' + id + '/enviar', {});
  return (r && r.data) || null;
}

export async function reenviarFE(id) {
  const r = await apiClient.post(BASE + '/' + id + '/reenviar', {});
  return (r && r.data) || null;
}

/**
 * Descarga un archivo FE (XML o PDF) y lo abre en una nueva pestana.
 * Usa el helper generico openProtectedFile.
 */
export async function abrirArchivoFE(id, tipo /* 'xml' | 'pdf' */) {
  const mime = tipo === 'xml' ? 'application/xml' : 'application/pdf';
  return openProtectedFile('/fe/' + id + '/' + tipo, mime);
}
